import { useAuth } from "@/auth/AuthProvider";
import { PersonalizableDashboard } from "@/dashboard/PersonalizableDashboard";
import { DEFAULT_LAYOUT_BY_ROLE, HOME_WIDGETS } from "@/dashboard/widgets";

interface HomePageProps {
  editing: boolean;
  onEditingChange: (editing: boolean) => void;
}

export function HomePage({ editing, onEditingChange }: HomePageProps) {
  const { user } = useAuth();
  if (!user) return null;

  const defaultActive =
    DEFAULT_LAYOUT_BY_ROLE[user.account_type] ?? DEFAULT_LAYOUT_BY_ROLE.pilot;

  return (
    <PersonalizableDashboard
      pageKey="home"
      widgets={HOME_WIDGETS}
      accountType={user.account_type}
      defaultActiveTypes={defaultActive}
      editing={editing}
      onEditingChange={onEditingChange}
      title="Home"
    />
  );
}
